
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gyms/[id]",
      function () {
        return require("private-next-pages/gyms/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gyms/[id]"])
      });
    }
  